import _ from "lodash";
import { DateRange } from "../../Steps/components/DatesAndGuests/useDatesAndGuests";
import { type DateValue, parseDate } from "@ttc3k/trekker";

function convertDateRangeToCalendarValue(range: DateRange): DateValue[] {
  const start = range.startDateISO.length > 0 ? range.startDateISO : undefined;
  const end = range.endDateISO.length > 0 ? range.endDateISO : undefined;
  return _.compact([start, end]).map(date => parseDate(date));
}

export { convertDateRangeToCalendarValue };
